export default function buildMakeFlowChart({ validate, validators }) {
  return function makeFlowChart({
    id,
    companyId,
    flowDeviceId,
    psi,
    gpm,
    createdBy,
    createdDate = new Date(),
    modifiedBy,
    modifiedDate = new Date(),
    deletedBy,
    deletedDate,
  }) {
    const schema = {
      id: {
        prettyName: 'ID',
        validators: [validators.isString(), validators.exactLength(36)],
      },
      companyId: {
        prettyName: 'Company ID',
        validators: [validators.isString(), validators.exactLength(36)],
      },
      flowDeviceId: {
        prettyName: 'Flow Device ID',
        validators: [validators.isString(), validators.exactLength(36)],
      },
      psi: {
        prettyName: 'PSI',
        validators: [validators.isNumber(), validators.notNull()],
      },
      gpm: {
        prettyName: 'GPM',
        validators: [validators.isNumber(), validators.notNull()],
      },
    };

    return Object.freeze({
      get id() { return id },
      get companyId() { return companyId },
      get flowDeviceId() { return flowDeviceId },
      get psi() { return psi },
      get gpm() { return gpm },
      get createdBy() { return createdBy },
      get createdDate() { return createdDate ? new Date(createdDate) : null },
      get modifiedBy() { return modifiedBy },
      get modifiedDate() { return modifiedDate ? new Date(modifiedDate) : null },
      get deletedBy() { return deletedBy },
      get deletedDate() { return deletedDate ? new Date(deletedDate) : null },
      validate() {
        const errors = validate(this, schema);
        if (errors.length > 0) {
          const message = errors.map(e => e.name + ': ' + e.message).join('\n');
          const validationError = new Error(message);
          validationError.name = 'ValidationError';
          throw validationError;
        }
      }
    });
  }
}